import { ArrowLeft } from 'lucide-react'
import { useTranslation } from '@/i18n'

interface ContextHeaderProps {
  message: string
  onBack: () => void
}

const ContextHeader = ({ message, onBack }: ContextHeaderProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex px-4 py-3 gap-3 bg-white dark:bg-dark-card border-b border-gray-200 dark:border-dark-border items-center flex-shrink-0">
      <button
        type="button"
        onClick={onBack}
        aria-label={t('chat:context_header.back_button')}
        className="flex-shrink-0 p-1 rounded-md hover:bg-gray-100 dark:hover:bg-dark-accent transition-colors"
      >
        <ArrowLeft className="w-5 h-5 text-gray-600 dark:text-gray-400" />
      </button>
      {/* The pinned question (the latest the user asked, pinnedQuestion.ts) is read in full: it
          wraps, and only a very long one scrolls. */}
      <span className="min-w-0 text-gray-700 dark:text-gray-300 font-medium whitespace-pre-wrap break-words max-h-48 overflow-y-auto">
        {message}
      </span>
    </div>
  )
}

export default ContextHeader
